import styled from "@emotion/styled";
import { BRAND_BLACK_TEXT_COLOR, WHITE_COLOR_NAME } from "styles/color-consts";
import Colors from "styles/colors";
import { LAYER_ONE } from "constants/z-index";
const FILTER_BUTTON_COLOR = "#cce5ff";
export const StyledWhatsNewPageLayoutMobileComponent = styled.div`
  .items-list-title-wrapper {
    margin: 44px 24px 0;

    .core-title-container .core-title {
      font-size: 1.5rem;
      font-weight: 500;
    }
  }

  .filter-button-wrapper {
    box-shadow: 0px 4px 6px rgba(29, 140, 242, 0.1);
    margin-bottom: 24px;
    position: sticky;
    top: 64px;
    background-color: ${Colors[WHITE_COLOR_NAME]};
    z-index: ${LAYER_ONE};

    .filter-button {
      display: inline-flex;
      flex-direction: row;
      background-color: ${FILTER_BUTTON_COLOR};
      padding: 4px 8px;
      border-radius: 4px;
      font-size: 1.25rem;
      font-weight: bold;
      color: ${Colors[BRAND_BLACK_TEXT_COLOR]};
      text-align: center;
      cursor: pointer;
      margin-bottom: 20px;
      margin: 24px;
    }

    .filter-icon-wrapper {
      margin-right: 4px;
      margin-top: 4px;

      svg {
        height: 28px;
      }
    }

    .filter-text {
      display: flex;
      align-items: center;
      font-weight: 500;
    }
  }

  &.no-scroll {
    overflow: hidden;
    position: fixed;
    height: 100%;
    width: 100%;
  }
`;
